import { UOM } from './uom'

export class Rate {
    amount: number
    unit: UOM
    zeroTariff ?: string

    constructor(amount: number, unit: UOM, zeroTariff ?: string) {
        this.amount = amount
        this.unit = unit
        this.zeroTariff = zeroTariff
    }
}